import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=089ba74c&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=089ba74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089ba74c",
  null
  
)

export default component.exports